import React from 'react';
import ReactDOM from 'react-dom';
import MapBox from './js/components/MapBox';

import './css/style.css'

const COMPONENTS = {
  MapBox
}

function renderAppInElement(el) {
  const Component = COMPONENTS[el.dataset.component];
  if (!Component) return;
  // get props from elements data attribute, like the post_id
  const props = Object.assign({}, el.dataset);
  ReactDOM.render(<Component {...props} />, el);
}

document
  .querySelectorAll('.__react-component')
  .forEach(renderAppInElement)

// Needed for Hot Module Replacement
if(typeof(module.hot) !== 'undefined') {
  module.hot.accept() // eslint-disable-line no-undef  
}





